import React, { useEffect, useState } from 'react'
import '../styles/Ecosistemas.css'
import { EcosistemasCards } from './EcosistemasCards'

export const Ecosistema = ({ecosistemas}) => {

    const [ecosistema, setEcosistema] = useState()

    useEffect(() => {
        if (ecosistemas?.length < 1 || ecosistemas === undefined) return
        let arregloEcosistema = []
        ecosistemas.forEach(element => {
          arregloEcosistema.push(<EcosistemasCards ecosistema={element} />)
        })
        setEcosistema(arregloEcosistema)
    }, [ecosistemas])

  return (
    <>
        <div id="ecosistemas" style={{ backgroundColor: '#F7F7F7' }}>
            <div className='banner__ecosistemas'>
                <h2>Tu ecosistema</h2>
                <p>Tu seguro viene acompañado de un ecosistema de beneficios adicionales.<br/>Activa tu cuenta y comienza a disfrutar de ellos.</p>
            </div>
            <div className='container carousel__ecosistemas'>
                {
                    ecosistema?.length > 0 && (
                        <> 
                            <div className='div__cards'>
                                {
                                    ecosistema.map((card, index) => {
                                        return (
                                            card
                                        )
                                    })
                                }
                            </div>
                        </>
                    )
                }
            </div>
            {/* <EcosistemasCards ecosistemas={ecosistemas} /> */}
        </div>
    </>
  )
}
